import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import styles from "./no-results.module.scss";
import { useTranslation } from "react-i18next";

export const NoResults: React.FC<{
  noSearchResults: React.ReactNode;
  noResults: React.ReactNode;
  isNoResults: boolean;
  isNoSearchResults?: boolean;
}> = ({ noSearchResults, noResults, isNoResults, isNoSearchResults }) => {
  const { t } = useTranslation();
  const noResRef = useRef<HTMLDivElement>(null);
  const [showDefaultNoResult, setShowDefaultNoResult] = useState(false);
  useEffect(() => {
    if (!noResRef.current || noResRef.current.innerText.length) return setShowDefaultNoResult(false);
    setShowDefaultNoResult(true);
  }, [noResRef]);
  return (
    <div data-testid={"no-results"} className={classnames(styles.noResults)}>
      {isNoResults && <div ref={noResRef}>{noResults}</div>}
      {isNoSearchResults && noSearchResults && <div>{noSearchResults}</div>}
      {showDefaultNoResult && <div>{t("no_results")}</div>}
    </div>
  );
};
